/** @jsxImportSource @emotion/react */
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
import RexContainer from '@app/components/ui/RexContainer/RexContainer'
import FeatureCallToAction from '../../components/Unauthorized/FeatureCallToAction'

export const PrioritisationFeatureCallToAction = () => {
  const prioritisationBannerImg = `${PUBLIC_ASSETS_BASE_URL}/images/shared/rex_prioritisation_hero.svg`

  const prioritisationLogoImg = `${PUBLIC_ASSETS_BASE_URL}/images/shared/rex_prioritisation_logo.svg`

  return (
    <RexContainer
      bgColor="#e8edefff"
      content={
        <FeatureCallToAction
          logo={prioritisationLogoImg}
          heading="Your organisation doesn't have access to Prioritisation right now."
          description="Adaptation planning demands significant time and resources, often within a limited budget. It can be challenging to know where to focus efforts. Prioritisation helps adaptation advisors identify which communities need attention most urgently by ranking adaptation areas based on exposure, vulnerability and consequences."
        />
      }
    >
      <img src={prioritisationBannerImg} alt="Prioritisation - Resilience Explorer" />
    </RexContainer>
  )
}
